export enum ShippingClaimReason {
  Late = "late",
  Damaged = "damaged",
  Lost = "lost",
  Stolen = "stolen",
}
